<script>
    import FilenameSelector from "../../components/FilenameSelector.svelte";
    import SectionButton from "../../components/SectionButton.svelte";
    import SectionTitle from "../../components/SectionTitle.svelte";
    import { navigate } from "svelte-navigator";
    import { createEventDispatcher, getContext } from "svelte";
    import { api_info, fetchWithAuthentication } from "../../api/client.js";
    import ResultMessage from "../../components/ResultMessage.svelte";

    const context = getContext(api_info);

    export let data_versions = [];
    let selectedData = ""; // { value, label}
    let uploading = false;
    let files;
    let uploadResponse = {};

    const dispatch = createEventDispatcher();

    function editData() {
        if (selectedData) {
            navigate(
                `/edit_data?db_name=raw_data&filename=${encodeURIComponent(
                    selectedData.value
                )}`
            );
        }
    }
    function uploadData() {
        if (files && files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener(
                "load",
                async () => {
                    uploading = true;
                    // this will then display a text file
                    const data = JSON.parse(reader.result);
                    try {
                        uploadResponse = await fetchWithAuthentication(
                            context,
                            "/upload_raw_dataset/",
                            {
                                data,
                            }
                        );
                        dispatch("file_uploaded");
                    } finally {
                        uploading = false;
                    }
                },
                false
            );

            if (files) {
                reader.readAsText(files[0]);
            }
        }
    }
</script>

<h3>1. ข้อมูลคำร้อง</h3>
<form class="form-horizontal">
    <div class="form-group">
        <label for="upload_doc" class="col-sm-3 control-label"
            >อัพโหลดไฟล์ข้อมูลคำร้อง</label
        >
        <div class="col-sm-4">
            <input
                type="file"
                class="form-control"
                id="upload_doc"
                bind:files
            />
        </div>
        <div class="col-sm-5">
            <button
                type="button"
                class="btn btn-primary"
                disabled={uploading || !files}
                on:click={uploadData}
            >
                {#if uploading}
                    <span class="glyphicon glyphicon-refresh spinning" />
                {/if}
                อัพโหลด</button
            >
            <ResultMessage response={uploadResponse} />
        </div>
    </div>

    <SectionTitle title="แก้ไขข้อมูลคำร้อง" />
    <FilenameSelector
        label="ข้อมูลคำร้อง"
        id="section1"
        items={data_versions}
        bind:value={selectedData}
    />
    <SectionButton label="แก้ไข" disabled={!selectedData} on:click={editData} />
</form>
